import Axios from "axios"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

export const requestCurrentUser = async () => {
  try {
    let data = await Axios.get("/api/auth/getCurrentUser")
    return data
  } catch (error) {
    throw error
  }
}

export const requestvalidRedirectUrl = async ({ payload }) => {
  const encodedUrl = encodeURIComponent(payload.path);
  try {
    let data = await Axios.get(`/api/auth/validUrl?path=${encodedUrl}`)
    return data
  } catch (error) {
    throw error
  }
}
